<script setup lang="ts">
defineProps({
  vertical: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <dt class="description-list--key" :class="{ 'is-vertical': vertical }">
    <slot />
  </dt>
</template>
